module.exports = __webpack_public_path__ + "static/media/change.1aea29f0.svg";